import { Record, Union } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { option_type, record_type, string_type, union_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { containsKey } from "../fable_modules/fable-library-js.4.24.0/Map.js";
import { Feat } from "../Shopfoo.Domain.Types/Security.js";
import { interpolate, toText } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { TranslationsModule_Empty, Translations_$reflection, TranslationKey_$reflection } from "../Shopfoo.Domain.Types/Translations.js";
import { unwrap, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { Helpers_$007CFirstException$007C, ErrorCategory_ofError, ErrorMessageModule_ofError, ErrorMessage__get_FullMessage } from "../Shopfoo.Domain.Types/Errors.js";

export class ErrorType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Business", "Technical"];
    }
}

export function ErrorType_$reflection() {
    return union_type("Shopfoo.Shared.Errors.ErrorType", [], ErrorType, () => [[], []]);
}

export class ErrorDetailLevel extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NoDetail", "Admin"];
    }
}

export function ErrorDetailLevel_$reflection() {
    return union_type("Shopfoo.Shared.Errors.ErrorDetailLevel", [], ErrorDetailLevel, () => [[], []]);
}

export class ErrorDetail extends Record {
    constructor(Exception) {
        super();
        this.Exception = Exception;
    }
}

export function ErrorDetail_$reflection() {
    return record_type("Shopfoo.Shared.Errors.ErrorDetail", [], ErrorDetail, () => [["Exception", string_type]]);
}

export function User_errorDetailLevel(user) {
    let matchResult, claims_1;
    if (user.tag === 1) {
        if (containsKey(new Feat(1, []), user.fields[1])) {
            matchResult = 0;
            claims_1 = user.fields[1];
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return new ErrorDetailLevel(1, []);
        default:
            return new ErrorDetailLevel(0, []);
    }
}

export function System_Exception__Exception_AsErrorDetail_Z68E96CA9(this$, level) {
    let matchResult;
    if (level != null) {
        if (level.tag === 1) {
            matchResult = 0;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return new ErrorDetail(toText(interpolate("%A%P()", [this$])));
        default:
            return undefined;
    }
}

export class ApiError extends Record {
    constructor(ErrorCategory, ErrorMessage, ErrorType, ErrorKey, ErrorDetail, Translations) {
        super();
        this.ErrorCategory = ErrorCategory;
        this.ErrorMessage = ErrorMessage;
        this.ErrorType = ErrorType;
        this.ErrorKey = ErrorKey;
        this.ErrorDetail = ErrorDetail;
        this.Translations = Translations;
    }
}

export function ApiError_$reflection() {
    return record_type("Shopfoo.Shared.Errors.ApiError", [], ApiError, () => [["ErrorCategory", string_type], ["ErrorMessage", string_type], ["ErrorType", ErrorType_$reflection()], ["ErrorKey", option_type(TranslationKey_$reflection())], ["ErrorDetail", option_type(ErrorDetail_$reflection())], ["Translations", Translations_$reflection()]]);
}

function ApiError_create(category, message, errorType, key, detail, translations) {
    return new ApiError(defaultArg(category, ""), message, errorType, key, detail, defaultArg(translations, TranslationsModule_Empty));
}

export function ApiError_Business_Z184EB5A(message, category, key, detail, translations) {
    return ApiError_create(category, message, new ErrorType(0, []), key, detail, translations);
}

export function ApiError_Technical_Z184EB5A(message, category, key, detail, translations) {
    return ApiError_create(category, message, new ErrorType(1, []), key, detail, translations);
}

export function ApiError_FromError_Z53E47AF1(error, level, key, translations) {
    const errorMessage = ErrorMessage__get_FullMessage(ErrorMessageModule_ofError(error));
    const errorCategory = (level.tag === 1) ? ErrorCategory_ofError(error) : "";
    switch (error.tag) {
        case 1:
            return ApiError_Technical_Z184EB5A(errorMessage, errorCategory, unwrap(key), unwrap(System_Exception__Exception_AsErrorDetail_Z68E96CA9(error.fields[0], level)), unwrap(translations));
        case 2:
        case 3:
        case 4:
            return ApiError_Business_Z184EB5A(errorMessage, errorCategory, unwrap(key), undefined, unwrap(translations));
        case 5:
            return ApiError_Business_Z184EB5A(errorMessage, errorCategory, unwrap(key), undefined, unwrap(translations));
        case 6:
            return ApiError_Technical_Z184EB5A(errorMessage, errorCategory, unwrap(key), undefined, unwrap(translations));
        case 7:
            return ApiError_Technical_Z184EB5A(errorMessage, errorCategory, unwrap(key), undefined, unwrap(translations));
        default:
            return ApiError_Business_Z184EB5A(errorMessage, errorCategory, unwrap(key), undefined, unwrap(translations));
    }
}

export function ApiError_FromException_Z57DF7D6E(_arg, user) {
    const exn = Helpers_$007CFirstException$007C(_arg);
    return ApiError_Technical_Z184EB5A(exn.message, undefined, undefined, unwrap(System_Exception__Exception_AsErrorDetail_Z68E96CA9(exn, User_errorDetailLevel(user))));
}

export function ApiError_ForAuthenticationError_2C0F150A(authError) {
    if (authError.tag === 1) {
        return ApiError_Technical_Z184EB5A("UserUnauthorized");
    }
    else {
        return ApiError_Technical_Z184EB5A("TokenInvalid");
    }
}

